<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.900000036"
    >
      <g transform="translate(-578, -312)">
        <g id="Kort" transform="translate(239, 312)">
          <g id="Group" transform="translate(339, 0)">
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
            <path
              id="Path"
              d="M3,9 C3,7.8954305 3.8954305,7 5,7 L19,7 C20.1045695,7 21,7.8954305 21,9 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,9 Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              id="Path"
              d="M8,7 L8,5 C8,3.8954305 8.8954305,3 10,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <line
              id="Path"
              x1="12"
              y1="12"
              x2="12"
              y2="12.01"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <path
              id="Path"
              d="M3,13 C8.66095141,15.8525719 15.3390486,15.8525719 21,13"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
